import React from "react";
import ReactDOM from "react-dom";
import { HashRouter, Route, Switch, Redirect, useHistory, useLocation } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./stores";
import { localStore } from "stores/localStore";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";

// Function to check if the user is authenticated
const isAuthenticated = () => {
  const token = localStore.getToken();
  console.log("Authentication Check - Token:", token);
  return !!token;
};

// Protected Route Component
const ProtectedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) => {
      console.log("Protected Route Access - Authenticated:", isAuthenticated());
      return isAuthenticated() ? <Component {...props} /> : <Redirect to="/auth" />;
    }}
  />
);

// Prevent navigating back to login if already authenticated
const PreventBackToAuth = () => {
  const history = useHistory();
  const location = useLocation();

  React.useEffect(() => {
    if (isAuthenticated() && location.pathname === "/auth") {
      console.log("User already authenticated, redirecting to admin...");
      history.replace("/admin");
    }
  }, [history, location]);

  return null; // This component does not render anything
};

console.log("Initial Authentication Status:", isAuthenticated());

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <HashRouter>
        <PreventBackToAuth /> {/* Prevent navigating back to login */}
        <Switch>
          <Route
            path="/auth"
            render={(props) =>
              isAuthenticated() ? <Redirect to="/admin" /> : <AuthLayout {...props} />
            }
          />
          <ProtectedRoute path="/admin" component={AdminLayout} />
          <Redirect from="/" to={isAuthenticated() ? "/admin" : "/auth"} />
        </Switch>
      </HashRouter>
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);
